import { useLingui } from '@lingui/react/macro';
import type { FC } from 'react';
import { PageMeta } from '@/base/PageMeta';
import { AboutUs } from './AboutUs';
import { Hero } from './Hero';
import { HERO_PRELOAD_IMAGES } from './HeroBackground';
import { LandingLayout } from './LandingLayout';
import { ReferralProgram } from './ReferralProgram';
import { Security } from './Security';
import { TradeTopCryptocurrencies } from './TradeTopCryptocurrencies';
import { WhyChooseUs } from './WhyChooseUs';

export const LandingPage: FC = () => {
  const { t } = useLingui();

  return (
    <LandingLayout>
      <PageMeta
        title={t`Iraq's First Crypto Exchange`}
        description={t`Trade with confidence on the only exchange fully built for your region. Buy, sell, and trade crypto in Iraq.`}
        localizedPath=""
        preloadImages={HERO_PRELOAD_IMAGES}
      />
      <Hero className="desktop:mb-20" />
      <AboutUs className="mb-20" />
      <TradeTopCryptocurrencies className="mb-20" />
      <ReferralProgram className="mb-20" />
      <WhyChooseUs className="mb-20" />
      <Security className="mb-20" />
    </LandingLayout>
  );
};
